import { isOtherSpecify } from "@cartographerio/topo-form";
import { Option, Result } from "@cartographerio/fp";
import { isFeatureF, isPoint, safePointToNgr, } from "@cartographerio/geometry";
import { hasKey, hasOptionalKey, isArrayOf, isBoolean, isNullable, isNumber, isObject, isRecordOf, isString, } from "@cartographerio/guard";
import { ExtendedRiverflySpeciesEnum, RiverflyFirstBreachActionEnum, RiverflyReasonNotTakenEnum, RiverflySampleTypeEnum, RiverflySecondBreachActionEnum, } from "@cartographerio/inventory-enums";
import { isAttachmentFolder, isTimestamp, } from "@cartographerio/types";
function isSiteAttributes(attrs) {
    return (isObject(attrs) &&
        hasOptionalKey(attrs, "catchment", isNullable(isString)) &&
        hasOptionalKey(attrs, "river", isNullable(isString)) &&
        hasOptionalKey(attrs, "site", isNullable(isString)) &&
        hasOptionalKey(attrs, "triggerLevel", isNullable(isNumber)));
}
function isObservations(observations) {
    return (isObject(observations) &&
        hasOptionalKey(observations, "recorded", isNullable(isTimestamp)) &&
        hasOptionalKey(observations, "sampleType", isNullable(RiverflySampleTypeEnum.isValue)) &&
        hasOptionalKey(observations, "sampleTaken", isNullable(isBoolean)) &&
        hasOptionalKey(observations, "sampleReasonNotTaken", isOtherSpecify(isNullable(RiverflyReasonNotTakenEnum.isValue))) &&
        hasKey(observations, "counts", isRecordOf(ExtendedRiverflySpeciesEnum.isValue, isNullable(isNumber))) &&
        hasKey(observations, "fixedPointPhotographs", isAttachmentFolder) &&
        hasOptionalKey(observations, "firstBreachAction", isNullable(RiverflyFirstBreachActionEnum.isValue)) &&
        hasOptionalKey(observations, "firstBreachReasonNotRepeated", isNullable(isString)) &&
        hasKey(observations, "secondBreachAction", isArrayOf(RiverflySecondBreachActionEnum.isValue)) &&
        hasOptionalKey(observations, "secondBreachIncidentNumber", isNullable(isString)) &&
        hasOptionalKey(observations, "secondBreachReasonNotReported", isNullable(isString)) &&
        hasKey(observations, "breachPhotographs", isAttachmentFolder) &&
        hasOptionalKey(observations, "additionalSurveyors", isNullable(isString)) &&
        hasOptionalKey(observations, "notes", isNullable(isString)));
}
export function isPartialData(data) {
    return (isObject(data) &&
        hasKey(data, "observations", isObservations) &&
        hasOptionalKey(data, "site", isNullable(isFeatureF(isPoint, isSiteAttributes))));
}
const g = Result.guard(isPartialData, "PartialData");
export function dataDescription(data) {
    return g(data).map((data) => [
        data.site?.properties?.catchment ?? "Unknown catchment",
        data.site?.properties?.river ?? "Unknown river",
        data.site?.properties?.site ?? "Unknown site",
        Option.wrap(data.site?.geometry)
            .map(safePointToNgr)
            .getOrElse(() => "Unknown location"),
    ].join(", "));
}
export function dataTimestamp(data) {
    return g(data).map((data) => data.observations.recorded ?? null);
}
export function dataGeometry(data) {
    return g(data).map((data) => data.site?.geometry ?? null);
}
export function copyData(data) {
    return g(data).map(data => ({
        ...data,
        observations: {
            ...data.observations,
            sampleReasonNotTaken: { selected: null, other: null },
            counts: {},
            secondSampleCounts: {},
            secondBreachAction: [],
        },
    }));
}
//# sourceMappingURL=parts.js.map